
import { IReport } from "@/api/types/stats";
import TitleActions from "@/components/affiliate/TitleActions.vue";
import BaseCard from "@/components/base/BaseCard.vue";
import TableWithFrontPaginationDesign from "@/components/base/table/TableWithFrontPaginationDesign.vue";
import { Affiliate } from "@/services/affiliates/Affiliate";
import { getFormatDate } from "@/utils/formatDates";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    components: { TitleActions, TableWithFrontPaginationDesign, BaseCard },
})

export default class AffiliateStatistic extends Vue {
    @Prop({ required: true }) affiliate!: Affiliate;

    isLoading: boolean = false;
    headers = [
        { text: 'Дата', value: 'dm_lead_date', sortable: true },
        { text: 'Кликов всего', value: 'mt_clicks_total', sortable: false },
        { text: 'Уники', value: 'mt_clicks_unique', sortable: false, align: 'center' },
        { text: 'Лидов всего', value: 'mt_leads_total', sortable: false, align: 'center' },
        { text: 'Лидов прин.', value: 'mt_leads_approved', sortable: false, align: 'center' },
        { text: 'Лид.на проверке', value: 'mt_leads_pending', sortable: false, align: 'center' },
        { text: 'Лид.отклонено', value: 'mt_leads_rejected', sortable: false, align: 'center' },
        { text: 'CRu, %', value: 'mt_cr_u', sortable: false, align: 'center' },
        { text: 'CRt, %', value: 'mt_cr_t', sortable: false, align: 'center' },
        { text: 'EPCu', value: 'mt_epc_u', sortable: false, align: 'center' },
        { text: 'EPCt', value: 'mt_epc_t', sortable: false, align: 'center' },
        { text: 'AR, %', value: 'mt_ar', sortable: false, align: 'center' },
        { text: 'Выпл.прин.', value: 'mt_payout_approved', sortable: false, align: 'center' },
    ];

    numberFormatting = [
        { slot: 'item.mt_clicks_total', key: 'mt_clicks_total', isMono: true, digits: 0 },
        { slot: 'item.mt_clicks_unique', key: 'mt_clicks_unique', isMono: true, digits: 0 },
        { slot: 'item.mt_leads_total', key: 'mt_leads_total', isMono: true, digits: 0 },
        { slot: 'item.mt_leads_approved', key: 'mt_leads_approved', isMono: true, digits: 0 },
        { slot: 'item.mt_leads_pending', key: 'mt_leads_pending', isMono: true, digits: 0 },
        { slot: 'item.mt_leads_rejected', key: 'mt_leads_rejected', isMono: true, digits: 0 },
        { slot: 'item.mt_cr_u', key: 'mt_cr_u', isMono: true },
        { slot: 'item.mt_cr_t', key: 'mt_cr_t', isMono: true },
        { slot: 'item.mt_epc_u', key: 'mt_epc_u', isMono: true },
        { slot: 'item.mt_epc_t', key: 'mt_epc_t', isMono: true },
        { slot: 'item.mt_ar', key: 'mt_ar', isMono: true },
        { slot: 'item.mt_payout_approved', key: 'mt_payout_approved', isMono: true, digits: 0 },
    ];

    uniqueData = [
        {
            slot: 'item.dm_lead_date',
            template: (item: IReport): string => getFormatDate(item.dm_lead_date!, 'dd.MM.yyyy'),
        },
    ];

    get getItems(): IReport[] {
        return this.affiliate.statistic!;
    }

    get isLoadingTable(): boolean {
        return this.affiliate.isLoadingData || this.isLoading;
    }
}

